import {
  LINK_DOCUSIGN_TCA_CIEEMG_FALLBACK,
  CAMPOS_APRENDIZ_BLOQUEADOS_EMPRESA,
  STATUS_CORES,
} from "../../constants/aprendiz.js";
import {
  formatDateBR,
  formatarCnpjCpf,
  isTelefonePlaceholder,
  sanitizeTelefone,
  parseSalario,
} from "../../utils/formatters.js";

export {
  LINK_DOCUSIGN_TCA_CIEEMG_FALLBACK,
  CAMPOS_APRENDIZ_BLOQUEADOS_EMPRESA,
  STATUS_CORES,
  formatDateBR,
  formatarCnpjCpf,
  isTelefonePlaceholder,
  sanitizeTelefone,
  parseSalario,
};

export const ANEXOS_SCHEMA_TCA_EMPREGADOR = [
  {
    id: "doc_comprovante_endereco",
    label: "Comprovante de Endereço",
    icon: "Home",
    required: true,
  },
  {
    id: "doc_declaracao_escolar",
    label: "Declaração escolar / histórico Ensino Médio",
    hint: "Até 30 dias de emissão",
    icon: "GraduationCap",
    required: true,
  },
  {
    id: "doc_identificacao_documento_indetificacao",
    label: "Documento de Identificação",
    icon: "IdCard",
    required: true,
  },
  {
    id: "doc_pis",
    label: "Nº do PIS",
    icon: "CreditCard",
    required: false,
  },
  {
    id: "doc_tipo_sanguineo",
    label: "Comprovante tipo sanguíneo",
    icon: "Droplet",
    required: false,
  },
  {
    id: "doc_certificado_reservista",
    label: "Certificado de Reservista",
    icon: "Shield",
    required: false,
  },
  {
    id: "doc_certidao_casamento",
    label: "Certidão de Casamento",
    icon: "FileText",
    required: false,
  },
  {
    id: "doc_titulo_eleitor",
    label: "Título de Eleitor",
    icon: "Vote",
    required: false,
  },
  {
    id: "doc_curriculum",
    label: "Currículo atualizado",
    icon: "User",
    required: false,
  },
  {
    id: "doc_curso_qualificacao",
    label: "Curso(s) de qualificação",
    icon: "Award",
    required: false,
  },
  {
    id: "doc_foto_3x4",
    label: "Foto 3x4 recente",
    icon: "Camera",
    required: true,
  },
];

export function formatarEnderecoLimpo(dados) {
  if (!dados) return "";
  if (typeof dados === "string") return dados.trim();

  const endPronto = String(dados.endereco || "").trim();
  if (endPronto && (endPronto.includes(",") || endPronto.includes("-"))) {
    return endPronto;
  }

  const logradouro = String(dados.logradouro || dados.endereco || "").trim();
  const numero = String(dados.numero || dados.numero_endereco || "").trim();
  const complemento = String(dados.complemento || "").trim();
  const bairro = String(dados.bairro || "").trim();
  const cidade = String(dados.cidade || dados.municipio || "").trim();
  const uf = String(dados.uf || dados.estado || dados.estado_endereco || "").trim();

  let linha = logradouro;
  if (numero) linha = linha ? `${linha}, ${numero}` : numero;
  if (complemento) linha = linha ? `${linha} - ${complemento}` : complemento;
  if (bairro) linha = linha ? `${linha} - ${bairro}` : bairro;
  if (cidade && uf) linha = linha ? `${linha} - ${cidade}/${uf}` : `${cidade}/${uf}`;
  else if (cidade) linha = linha ? `${linha} - ${cidade}` : cidade;

  if (dados.cep && !linha.includes(dados.cep)) {
    const cepStr = `CEP: ${dados.cep}`;
    linha = linha ? `${linha}, ${cepStr}` : cepStr;
  }

  return linha.trim();
}

export const parseTarifa = (val) => {
  if (val === null || val === undefined || val === "") return null;
  if (typeof val === "number") return val;
  const cleaned = String(val)
    .replace("R$", "")
    .replace(/\s/g, "")
    .replace(/\./g, "")
    .replace(",", ".");
  const num = parseFloat(cleaned);
  return isNaN(num) ? null : num;
};

export const formatBRL = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "" || trimmed === "R$ 0,00") return "";
    const num = parseSalario(trimmed);
    if (!num || isNaN(num)) return trimmed;
    return num.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    });
  }
  if (typeof value === "number") {
    if (!value) return "";
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    });
  }
  return String(value);
};
